import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyGeneric = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.159 8.256L27.708 5.707C27.889 5.526 28.001 5.276 28.001 5C28.001 4.448 27.553 4 27.001 4C26.725 4 26.475 4.112 26.294 4.293L23.745 6.842C21.654 5.071 18.95 4.001 16.001 4.001C13.052 4.001 10.348 5.071 8.257 6.842L5.708 4.293C5.527 4.112 5.277 4 5.001 4C4.449 4 4.001 4.448 4.001 5C4.001 5.276 4.113 5.526 4.294 5.707L6.843 8.256C5.072 10.347 4.002 13.051 4.002 16C4.002 18.949 5.072 21.653 6.843 23.744L4.294 26.293C4.113 26.474 4.001 26.724 4.001 27C4.001 27.552 4.449 28 5.001 28C5.277 28 5.527 27.888 5.708 27.707L8.257 25.158C10.348 26.929 13.052 27.999 16.001 27.999C18.95 27.999 21.654 26.929 23.745 25.158L26.294 27.707C26.475 27.888 26.725 28 27.001 28C27.553 28 28.001 27.552 28.001 27C28.001 26.724 27.889 26.474 27.708 26.293L25.159 23.744C26.93 21.653 28 18.949 28 16C28 13.051 26.93 10.347 25.159 8.256ZM6 16C6 10.486 10.486 6 16 6C21.514 6 26 10.486 26 16C26 21.514 21.514 26 16 26C10.486 26 6 21.514 6 16Z" />
	</svg>
);

export default CurrencyGeneric;
